import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { ExplorableItemType } from '../models/ContentType';
import { ViewStatFields } from '../models/ContentTypes';
import { IRecentContentInfo } from '../models/IRecentContentInfo';
import { Module } from '../Module';
import { GetDetailedRecentsRequest } from '../ServerApi/requests/GetDetailedRecentsRequest';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { FetcherFactory } from '../services/FetcherFactory';
import { ResourceQuery } from './ResourceQuery';

export class Recents {
  public static $inject = ['FetcherFactory'];

  private getRecentViews: IListFetcher<IRecentContentInfo>;

  constructor(FetcherFactory: FetcherFactory) {
    this.getRecentViews = FetcherFactory.getServerResourceFetcher(GetDetailedRecentsRequest, ServerApiMapper.recentItems);
  }

  public all(contentTypes: ReadonlyArray<ExplorableItemType>, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IRecentContentInfo> {
    let objectTypes: string[] = contentTypes.map((contentType) => {
      if (contentType === 'view') {
        return 'VIEW';
      } else if (contentType === 'metric') {
        return 'METRIC';
      }
      return '';
    }).filter((value => value.length > 0));

    if (objectTypes.length === 0) {
      objectTypes = ['VIEW'];
    }

    return new ResourceQuery(this.getRecentViews)
      .withExtraParams({'viewStatFields': ViewStatFields, 'objectTypes': objectTypes})
      .withFilters(additionalFilterClauses);
  }
}

Module.instance().service('Recents', Recents);
